module.exports = __webpack_public_path__ + "img/odmeny.17dca8e8.png";